import React from 'react'
import { Link } from 'gatsby'

const Footer = () => (
  <footer>
    <ul className="link">
      <li><Link to="/">ホーム</Link></li>
      {/* <li><Link to="/">プライバシーポリシー</Link></li> */}
    </ul>
    <p className='copyright'>&copy; KameWalk</p>
  </footer>
)
export default Footer;